/* eslint-disable */
import store from '@/store'
import apiAIT from '@/common/ateneaInvoiceToolsApi'

export default {
  name: 'form-sagepaymentsupdate',
  data: () => {
    return {
      user: store.getters.getUser,
      title: 'Pagos Sage: Actualización de datos',
    }
  },

  created() {
  },
  computed: {
  },
  methods: {
    
  }
}
